import React, { useContext, useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import { AuthContext } from "../../context/AuthContext";
import Topbar from "../../components/Recruiter/Topbar/Topbar";
import ClipLoader from "react-spinners/ClipLoader";

const AdminUsage = () => {
    const { token } = useContext(AuthContext);
    const serverURL = process.env.REACT_APP_SERVER_URL;
    const secretKey = process.env.REACT_APP_SECRETKEY;
    
    const [usageStat, setUsageStat] = useState({});
    const [expandedCompanies, setExpandedCompanies] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const fetchUsage = async () => {
        try {
            setIsLoading(true);
            const encryptedMetadataAll = localStorage.getItem('metadata');
            const decryptedMetadataAll = JSON.parse(CryptoJS.AES.decrypt(encryptedMetadataAll, secretKey).toString(CryptoJS.enc.Utf8));
            const uid = decryptedMetadataAll.uid;
            const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({ uid }), secretKey).toString();

            const response = await fetch(`${serverURL}/subscription/getUsageDetails`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    token: token,
                },
                body: JSON.stringify({ data: encryptedData }),
            });

            const data = await response.json();
            const decryptedData = JSON.parse(
                CryptoJS.AES.decrypt(data.data, secretKey).toString(CryptoJS.enc.Utf8)
            );

            if (decryptedData) {
                setUsageStat(decryptedData);
            }
        } catch (err) {
            console.error("Error fetching usage data:", err);
        } finally{
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchUsage();
    }, []);

    const toggleCompany = (companyId) => {
        setExpandedCompanies((prev) => ({ ...prev, [companyId]: !prev[companyId] }));
    };
    const keyMapping = {
        job: "No. of Jobs",
        jd: "Job Descriptions",
        resume: "Resumes",
        token: "API Tokens",
        job_ai: "AI-Powered Job Processing",
        email: "Emails Sent",
        email_ai_usage: "AI-Generated Emails",
        email_count: "Total Emails",
        no_of_cand: "Number of Candidates",
        no_of_recruiters: "Number of Recruiters",
        sms_count: "SMS Sent",
        whats_app_count: "WhatsApp Messages Sent",
    };
    

    return (
        <div className="radial-gradient-bg">
            {isLoading && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="flex flex-col items-center">
                    <ClipLoader color="#3498db" loading={isLoading} size={50} />
                    <span className="text-white mt-4">Fetching Usage Stats...</span>
                    </div>
                </div>
            )}
            <Topbar />
            <div className="w-[94.5%] bg-white bg-opacity-50 ml-12 mt-4 rounded-xl p-6">
                {Object.entries(usageStat).map(([companyId, companyData]) => (
                    <div key={companyId} className="mb-6 border-b pb-4">
                        <div 
                            className="cursor-pointer flex justify-between items-center p-3 bg-gray-200 rounded-md"
                            onClick={() => toggleCompany(companyId)}
                        >
                            <h3 className="text-lg font-semibold">{companyData.company_details?.name || "Unknown Company"}</h3>
                            <span>{expandedCompanies[companyId] ? "▲" : "▼"}</span>
                        </div>

                        {expandedCompanies[companyId] && (
                            <div className="mb-3">
                                <div className="p-4 bg-gray-100 rounded-md mb-4">
                                    <h4 className="font-semibold">Company Overview</h4>
                                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                        {Object.entries(companyData.usageTrackingDetailsCid || {}).map(([key, value]) => (
                                            <div key={key} className="bg-blue-100 p-2 rounded">
                                                <strong className="capitalize">{keyMapping[key] || key.replace(/_/g, " ")}: </strong>
                                                {String(value)}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                
                                {Object.entries(companyData.users || {}).map(([userId, userData]) => (
                                    <div key={userId} className="p-4 border rounded-lg shadow-md mb-4">
                                        <h4 className="font-semibold text-lg">{userData.subscription?.user_email || "Unknown User"}</h4>
                                    {/* Plan Details */}
                                        {/* <h5 className="font-semibold mt-3">Current Plan Details</h5>
                                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                            {Object.entries(userData.plan || {}).filter(([key]) => key != "duration").map(([key, value]) => {
                                                const isDate = typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value);
                                                const formattedValue = isDate ? new Date(value).toLocaleString() : String(value);
                                                return(
                                                <div key={key} className="bg-blue-100 p-2 rounded">
                                                    <strong className="capitalize">{key.replace(/_/g, " ")}:</strong> {formattedValue}
                                                </div>)
                                            })}
                                            {Object.entries(userData.plan || {}).filter(([key]) => key === "duration").map(([key, value]) => (
                                                <div key={key} className="bg-blue-100 p-2 rounded">
                                                    <strong className="capitalize">{key.replace(/_/g, " ")}:</strong> 
                                                    {Object.entries(value).map(([key,value]) => (
                                                        <span>{value} {key}</span>
                                                    ))}
                                                </div>
                                            ))}
                                        </div> */}

                                        <h5 className="font-semibold mt-3">Current & Previous Plans Usage</h5>
                                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                            {Object.entries(userData.usage || {}).map(([planId, usageDetails]) => {
                                                const currentPlan = userData.plan?.plans_id == planId ? true : false;
                                                const planDetails = userData.plan || {};
                                                const prePlan = userData.pre_plans?.[planId]?.name;
                                                const curPlan = userData?.plan?.name;
                                                return (
                                                    <div key={planId} className={`p-2 rounded ${currentPlan ? "!border-green-500 bg-white border" : "border-gray-300 bg-gray-100 border"}`}>
                                                        <div className="flex" style={{justifyContent:'space-between'}}>
                                                        <h6 className="font-semibold">{currentPlan ? curPlan: prePlan}</h6>
                                                        {currentPlan && <span style={{color:'white',padding:'2px 10px',backgroundColor:'green',borderRadius:'10px'}}>Current</span>}
                                                        </div>
                                                        {Object.entries(usageDetails).map(([key, usedValue]) => {
                                                            const totalValue = planDetails[key];
                                                            return (
                                                                <div key={key} className="flex">
                                                                    <strong className="capitalize w-[50%]">{keyMapping[key] || key.replace(/_/g, " ")}: </strong>
                                                                    <span className="w-[50%]">{`${usedValue}/${totalValue} used`}</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminUsage;
